/**
 * Headlight context-entity catalog for the data-import GUID strategy.
 *
 * The five "context" entities whose identity can be baked into a child record's GUID so the GUID is
 * globally unique without a true UUID (e.g. a Line Item on Contract 10 / Project 01278 composes to
 * `UI_C10_P01278_LI8675309`). Each entity has a STABLE abbreviation — load-bearing for cross-import
 * matching, since the same source data must always yield the same GUID — plus its natural-key field
 * (informational; the uploader maps the actual source column in the GUID-strategy panel).
 *
 * This is the ONE host-specific piece of the GUID work; the composer + strategy compiler live in
 * meadow-integration and the configuration UI lives in pict-section-dataimport. Passed into the wizard
 * via DataImport-Provider as `ContextEntityCatalog`.
 */
module.exports =
{
	Project: { Abbrev: 'P', KeyField: 'Name', GUIDSize: 64 },
	Contract: { Abbrev: 'C', KeyField: 'Name', GUIDSize: 64 },
	Sample: { Abbrev: 'S', KeyField: 'Name', GUIDSize: 64 },
	PhysicalAsset: { Abbrev: 'PA', KeyField: 'Name', GUIDSize: 128 },
	Inspection: { Abbrev: 'I', KeyField: 'Name', GUIDSize: 36 },
};
